var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-4 p-2"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Create Post","aria-label":"Recipient's username","aria-describedby":"basic-addon2"},on:{"click":_vm.redirect}})])
}
var staticRenderFns = []

export { render, staticRenderFns }